import React from "react";
import { LoanPaymentContainer } from "../../../containers";

const LoanPayment = (props) => {
  return <LoanPaymentContainer {...props} />;
};

export default LoanPayment;
